import { Injectable } from "@angular/core";
import { NotificationMapper } from "./notification.mapper";
import { CrudAbstractRepository } from "../crud-abstract/crud-abstract.repository";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { map } from "rxjs/operators";
import { CrudAbstractModel } from "../crud-abstract/crud-abstract.model";

@Injectable()
export class NotificationRepository extends CrudAbstractRepository {
  getMapper(): any {
    return NotificationMapper.map;
  }

  getEndpoint(): string {
    return "notification";
  }

  public getMyHighlights(): Observable<Notification[]> {
    return this.http
      .get<Notification[]>(
        `${environment.apiUrl}` + "/me/notification/highlights",
      )
      .pipe(map((response) => response.map(this.getMapper())));
  }

  public getMyNotifications(): Observable<Notification[]> {
    return this.http
      .get<Notification[]>(`${environment.apiUrl}` + "/me/notification")
      .pipe(map((response) => response.map(this.getMapper())));
  }

  public markAsRead(model: CrudAbstractModel): Observable<Notification> {
    return this.http.patch<Notification>(
      `${environment.apiUrl}/me/${this.getEndpoint()}/${model.getId()}/read`,
      model.getRequestParams(),
    );
  }
}
